<div
    class="flex min-h-screen items-center justify-center bg-cover bg-center p-8"
    style="background-image: url('/welcome-image.png')"
>
    <div class="w-full max-w-2xl animate-[slideIn_0.5s_ease-out] rounded-lg bg-white p-8 text-center shadow-xl md:p-12">
        <div class="mb-8 flex items-center justify-center">
            <img src="/ballance-logo.png" alt="Ballance" class="h-auto w-[200px]" />
        </div>

        <div>
            <div class="mb-2 text-red-500">There was an error loading the application</div>

            <div class="mx-auto w-[80%] p-6">
                @switch (messageType()) {
                    @case (ErrorTypeEnum.API_ERROR) {
                        <p class="text-gray-600">
                            Looks like there was an error while the UI was trying to reach the API. You can try again by
                            refreshing the page. If the problem persists, please contact support.
                        </p>
                    }
                    @case (ErrorTypeEnum.NO_ROLES) {
                        <p class="text-gray-600">
                            Looks like you don't have any roles assigned to you. Please contact support.
                        </p>
                    }
                }
            </div>

            <div>
                <p-button label="Logout" icon="pi pi-sign-out" severity="primary" (click)="logout.emit()" />
            </div>
        </div>
    </div>
</div>

<style>
    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
